module.exports = __webpack_public_path__ + "static/media/user_funnel_analysis_mobile_en.4c0c4e8e.png";